<div class="summary" [ngClass]="{'d-block flex-1' : !isGrid,'classObject': classObject}">
    <div>
        <div class="summary_title">{{title}}</div>
        <div class="summary_value" [matTooltip]="tooltip ? value : null">{{value}}</div>
        <div class="summary_loader" *ngIf="value == null && isGrid"></div>
    </div>

    <ng-content></ng-content>
</div>